import {useContext, useRef, useState} from 'react'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import MoleculeModal from '@s-ui/react-molecule-modal'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconCircleWarningOutline from '@adv-mt/mt-svg-icons/lib/CircleWarningOutline.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

import {useMessagingContext} from '../../useMessagingContext/index.js'

const N_ITEMS_REASONS = 14

const ModalTips = () => {
  const {domain, i18n} = useContext(Context)
  const {state} = useMessagingContext()
  const [buyerName, setBuyerName] = useState(null)

  const currentState = useRef(null)
  currentState.current = state

  const {interactionUrl} = currentState.current
  const {searchParams} = new URL(interactionUrl)
  const tradeId = searchParams.get('tradeId')

  useMount(async () => {
    const [buyerTradeDataError, buyerTradeDataResponse] = await domain
      .get('get_buyer_trade_data_transactions_use_case')
      .execute({tradeId})
    const buyerTradeData = buyerTradeDataError ? {} : buyerTradeDataResponse

    const {name = null} = buyerTradeData || {}

    setBuyerName(name)
  })

  return (
    <div className="mt-TransactionSellerCancelledVehicleModal-tip">
      <span>
        {buyerName
          ? i18n.t('VEHICLE_TRANSACTION.SELLER_CANCELLED_VEHICLE.TIP', {
              buyerName
            })
          : i18n.t('VEHICLE_TRANSACTION.SELLER_CANCELLED_VEHICLE.TIP_FALLBACK')}
      </span>
    </div>
  )
}

const HelpText = () => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const imageUrl = `${URL_STATICS_IMAGES}pictograms/Warning.svg`

  return (
    <div className="mt-TransactionSellerCancelledVehicleModal-helpText">
      <img src={imageUrl} height={48} width={58} alt={i18n.t('VEHICLE_TRANSACTION.CANCELLED_VEHICLE.HELP_TEXT')} />
      <div className="mt-TransactionSellerCancelledVehicleModal-helpTextInfo">
        {i18n.t('VEHICLE_TRANSACTION.CANCELLED_VEHICLE.HELP_TEXT')}
      </div>
    </div>
  )
}

export const SellerCancelledVehicleTransactionModal = () => {
  const {domain, i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const urlStaticsImages = domain.get('config').get('URL_STATICS_IMAGES')

  const imageUrl = `${urlStaticsImages}illustrations/error-500.svg`

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-TransactionSellerCancelledVehicleModal-modalContainer">
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: (
                <div className="mt-TransactionSellerCancelledVehicleModal-modalChildren">
                  <HelpText />
                  <strong>{i18n.t('VEHICLE_TRANSACTION.CANCELLED_VEHICLE.MAIN_TEXT')}</strong>
                  <div className="mt-TransactionSellerCancelledVehicleModal-listItems">
                    {Array.from(Array(N_ITEMS_REASONS).keys()).map(i => (
                      <div className="mt-TransactionSellerCancelledVehicleModal-listItem">
                        <div className="mt-TransactionSellerCancelledVehicleModal-listItemIcon">
                          <IconCircleWarningOutline size="medium" />
                        </div>
                        <span>{i18n.t(`VEHICLE_TRANSACTION.CANCELLED_VEHICLE.REASON_${i}`)}</span>
                      </div>
                    ))}
                  </div>
                  <ModalTips />
                </div>
              ),
              headerImage: (
                <div className="mt-TransactionModal-contentHeaderImageWrapper">
                  <AtomImage
                    alt={i18n.t('VEHICLE_TRANSACTION.CANCELLED_VEHICLE.TITLE')}
                    className="mt-TransactionModal-contentHeaderImage"
                    src={imageUrl}
                  />
                </div>
              ),
              title: i18n.t('VEHICLE_TRANSACTION.CANCELLED_VEHICLE.TITLE'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
